import {Stack} from 'expo-router';
import {GestureHandlerRootView} from "react-native-gesture-handler";
import {SafeAreaProvider} from "react-native-safe-area-context";

export default function AuthLayout() {
    return (
        <GestureHandlerRootView style={{ flex: 1 }}>
            <SafeAreaProvider>
                <Stack screenOptions={{ headerShown: false }}>
                    <Stack.Screen name="(auth)/login" />
                    <Stack.Screen name="(auth)/scanner" />
                </Stack>
            </SafeAreaProvider>
        </GestureHandlerRootView>
    );
}
